import { render, staticRenderFns } from "./CSIllustrationSelectorTest.vue?vue&type=template&id=1f2ec372&scoped=true&"
import script from "./CSIllustrationSelectorTest.vue?vue&type=script&lang=js&"
export * from "./CSIllustrationSelectorTest.vue?vue&type=script&lang=js&"
import style0 from "./CSIllustrationSelectorTest.vue?vue&type=style&index=0&id=1f2ec372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2ec372",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
